import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

import { questionnaireDetailDtoSchema } from '../schemas/questionnaireSchemas';
import { questionnaireKeys } from './questionnaireKeys';

export function useQuestionnaire(questionnaireId: string | undefined) {
  const tenantId = useTenantStore((s) => s.tenantId);

  return useQuery({
    queryKey: questionnaireKeys.detail(questionnaireId ?? ''),
    queryFn: async ({ signal }) => {
      const raw = await apiClient
        .get(`api/v1/t/${tenantId}/questionnaires/${questionnaireId}`, { signal })
        .json();
      return questionnaireDetailDtoSchema.parse(raw);
    },
    enabled: !!tenantId && !!questionnaireId,
  });
}
